import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const API_BASE = `${API_BASE_URL}/api/non-conformances`;

export const nonConformanceService = {
  create: async (data) => {
    const response = await axios.post(API_BASE, data);
    return response.data;
  },

  getByLedger: async (eLedgerId, filters = {}) => {
    const params = new URLSearchParams();
    if (filters.status) params.append('status', filters.status);
    if (filters.severity) params.append('severity', filters.severity);
    if (filters.nc_type) params.append('nc_type', filters.nc_type);
    const response = await axios.get(`${API_BASE}/ledger/${eLedgerId}?${params}`);
    return response.data;
  },

  getSummary: async (eLedgerId) => {
    const response = await axios.get(`${API_BASE}/ledger/${eLedgerId}/summary`);
    return response.data;
  },

  getById: async (id) => {
    const response = await axios.get(`${API_BASE}/${id}`);
    return response.data;
  },

  updateStatus: async (id, data) => {
    const response = await axios.put(`${API_BASE}/${id}/status`, data);
    return response.data;
  },

  updateActionPlans: async (id, data) => {
    const response = await axios.put(`${API_BASE}/${id}/action-plans`, data);
    return response.data;
  }
};

export default nonConformanceService;
